import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { BooleanOperators, FilterOperators, getIconForOperator, textFilterOptions } from '@opengov/reporting-types/src/reportFilters';
import classnames from 'classnames2';
import React, { createRef } from 'react';
import { Button } from '../Button';
import { CheckboxIcon } from '../CheckboxIcon';
import { Dropdown } from '../Dropdown';
import { useListboxControls } from '../hooks/useListboxControls';
import { Icon } from '../Icon/Icon';
import { Input } from '../Input';
import { InputGroup } from '../InputGroup/InputGroup';
import { Label } from '../Label/Label';
import { ScrollShadow } from '../ScrollShadow';
import { Select as LegacySelect } from '../Select';
import { Select } from '../SelectA11Y';
import { Text } from '../Text';
import { booleanOperatorChangeDataAttribute, booleanOperatorLabelDataAttribute, changeFilterOperator, removeFilterButtonDataAttribute } from './DataAttributes';
import { FilterActions } from './FilterActions';
import multiFilterStyles from './FilterTextMulti.scss';
import { FilterTextMultiFilterInput } from './FilterTextMultiFilterInput';
import { FilterTextMultiFilterSuffix } from './FilterTextMultiFilterSuffix';
import styles from './styles.scss';
export var filterLimit = 30;
var locale = {
  new: 'New',
  add: 'Add',
  added: 'Added',
  warningHeader: 'Unable to add any new filters',
  warningBody: "This report has met its max of ".concat(filterLimit, " filters. Remove a filter to add another."),
  oversizeWarning: "Can't preview values when over a million rows.",
  if: 'If',
  addFromOptions: 'Add from options',
  filter: 'Filter',
  done: 'Done'
};
var textInput = createRef();

var CheckListItem = function CheckListItem(_ref) {
  var id = _ref.id,
      isChecked = _ref.isChecked,
      label = _ref.label,
      count = _ref.count,
      highlighted = _ref.highlighted,
      dataTest = _ref.dataTest;
  return React.createElement("li", {
    id: id,
    "data-test": dataTest,
    "aira-label": label,
    className: classnames(multiFilterStyles.optionRow, highlighted && multiFilterStyles.optionHighlighted),
    role: "option",
    "aria-selected": isChecked
  }, React.createElement(CheckboxIcon, {
    checked: isChecked,
    color: isChecked ? '#1f76d8' : '#b5b9bd'
  }), React.createElement(Text, {
    size: "small",
    font: "default",
    color: "light",
    className: multiFilterStyles.optionLabel
  }, label), React.createElement(Text, {
    size: "minimum",
    font: "condensed",
    color: "light",
    className: multiFilterStyles.optionCount
  }, count));
};

var Options = function Options(_ref2) {
  var filterOptions = _ref2.filterOptions,
      filterList = _ref2.filterList,
      queryOperator = _ref2.queryOperator,
      handleSearchSelection = _ref2.handleSearchSelection;

  var _useListboxControls = useListboxControls({
    itemIdPrefix: 'text-multi-item',
    onChange: function onChange(option) {
      handleSearchSelection(option.label);
    },
    isMultiSelectable: true
  }),
      listBoxRef = _useListboxControls.listBoxRef,
      handleClick = _useListboxControls.handleClick,
      handleKeyDown = _useListboxControls.handleKeyDown,
      handleBlur = _useListboxControls.handleBlur,
      setupFocus = _useListboxControls.setupFocus,
      activeDescendantId = _useListboxControls.activeDescendantId;

  var options = filterOptions.entrySeq().map(function (option, i) {
    return {
      id: "text-multi-item-".concat(i),
      label: option[0],
      count: option[1]
    };
  });
  return React.createElement(ScrollShadow, {
    height: 200,
    role: "listbox",
    ref: listBoxRef,
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event, options);
    },
    onMouseDown: function onMouseDown(event) {
      return handleClick(event, options);
    },
    onFocus: setupFocus,
    onBlur: handleBlur,
    ariaMultiselectable: true,
    ariaActiveDescendent: activeDescendantId
  }, options.size > 0 && options.map(function (option) {
    var active = filterList.find(function (fil) {
      return fil.text === option.label && fil.operator === queryOperator;
    });
    return React.createElement(CheckListItem, {
      key: option.id,
      id: option.id,
      dataTest: "checkbox-".concat(option.label),
      highlighted: activeDescendantId === option.id,
      isChecked: !!active,
      label: option.label,
      count: option.count
    });
  }));
};

export var FilterTextMulti = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterTextMulti, _React$Component);

  var _super = _createSuper(FilterTextMulti);

  function FilterTextMulti(props) {
    var _this;

    _classCallCheck(this, FilterTextMulti);

    _this = _super.call(this, props);

    _this.handleApplyFilter = function () {
      _this.state.multiFilter.filters.length === 0 ? _this.props.onClearFilter() : _this.props.onApplyFilter(_this.state.multiFilter);
    };

    _this.handleClearFilter = function () {
      return _this.props.onClearFilter();
    };

    _this.handleQueryOperatorChange = function (operator) {
      return _this.setState({
        queryOperator: operator
      });
    };

    _this.handleTextChange = function (text) {
      return _this.setState({
        filterString: text
      });
    };

    _this.handleBooleanOperatorChange = function (operator) {
      _this.setState({
        formIsDirty: true,
        multiFilter: _objectSpread(_objectSpread({}, _this.state.multiFilter), {}, {
          booleanOperator: operator
        })
      });
    };

    _this.handleDropdownSelection = function (filter) {
      var existingMultiFilter = _this.state.multiFilter;
      existingMultiFilter.filters = existingMultiFilter.filters || [];
      existingMultiFilter.filters.push({
        text: filter,
        operator: _this.state.queryOperator
      });

      _this.setState({
        filterString: '',
        formIsDirty: true,
        multiFilter: existingMultiFilter
      });
    };

    _this.handleFilterAdd = function (a) {
      var existingMultiFilter = _this.state.multiFilter;
      existingMultiFilter.filters.push({
        text: _this.state.filterString,
        operator: _this.state.queryOperator
      });

      _this.setState({
        filterString: '',
        formIsDirty: true,
        multiFilter: existingMultiFilter
      });
    };

    _this.handleSearchSelection = function (filter) {
      if (_this.state.multiFilter.filters.find(function (fil) {
        return fil.text === filter && fil.operator === _this.state.queryOperator;
      })) {
        var existingState = _this.state;
        existingState.multiFilter.filters = existingState.multiFilter.filters.filter(function (fil) {
          return fil.text !== filter || fil.operator !== _this.state.queryOperator;
        });
        existingState.formIsDirty = true;

        _this.setState(existingState);
      } else {
        _this.handleDropdownSelection(filter);
      }
    };

    _this.handleSearchChange = function (search) {
      return _this.setState({
        searchString: search
      });
    };

    _this.handleSearch = function () {
      _this.props.getFilterOptions(_this.state.searchString);

      _this.setState({
        loadingSearch: true
      });
    };

    _this.handleRemoveFilter = function (ndx) {
      var existingMultiFilter = _this.state.multiFilter;
      existingMultiFilter.filters = existingMultiFilter.filters.filter(function (filter, ndx2) {
        return ndx2 !== ndx;
      });

      _this.setState({
        formIsDirty: true,
        multiFilter: existingMultiFilter
      });
    };

    _this.toggleDropdown = function (show) {
      var existingState = _this.state;
      existingState.showDropdown = show;

      _this.setState(existingState);
    };

    var sortedOptions = JSON.parse(JSON.stringify(textFilterOptions)); // for large datasets, put contains/not contains before equals/not equals

    if (!props.bypassMultiFilterLimit && props.filterState.rowCount > 1000000 && sortedOptions[0].id === FilterOperators.Equal) {
      sortedOptions.splice(2, 0, sortedOptions.splice(0, 1)[0], sortedOptions.splice(0, 1)[0]);
    }

    _this.state = {
      largeDataset: !props.filterState.bypassMultiFilterLimit && props.filterState.rowCount > 1000000,
      filterString: props.filterState.text || '',
      formIsDirty: false,
      queryOperator: props.filterState.queryOperator || FilterOperators.Contain,
      multiFilter: {
        booleanOperator: props.filterState.booleanOperator,
        filters: props.filterState.filters ? props.filterState.filters.toJS() : []
      },
      filterOptions: props.filterState.filterOptions,
      searchString: props.filterState.searchString || '',
      showDropdown: false,
      loadingSearch: false,
      sortedFilterOptions: sortedOptions
    };
    return _this;
  }

  _createClass(FilterTextMulti, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.filterState.filterOptions !== nextProps.filterState.filterOptions) {
        this.setState({
          filterOptions: nextProps.filterState.filterOptions,
          loadingSearch: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          multiFilter = _this$state.multiFilter,
          filterString = _this$state.filterString,
          queryOperator = _this$state.queryOperator,
          largeDataset = _this$state.largeDataset,
          filterOptions = _this$state.filterOptions,
          searchString = _this$state.searchString,
          sortedFilterOptions = _this$state.sortedFilterOptions;
      var booleanOperator = multiFilter.booleanOperator,
          filters = multiFilter.filters;
      var hasFilters = filters.length > 0;
      var filterLimitReached = filters.length === filterLimit;
      var filterList = this.state.multiFilter.filters;
      var inputField;

      if (!largeDataset && (queryOperator === FilterOperators.Equal || queryOperator === FilterOperators.NotEqual)) {
        inputField = React.createElement(Dropdown, {
          id: "equals-options-popover",
          buttonText: locale.addFromOptions,
          buttonSize: 'small',
          isOpen: this.state.showDropdown,
          onOpen: function onOpen() {
            return _this2.toggleDropdown(!_this2.state.showDropdown);
          },
          onClose: function onClose() {
            return _this2.toggleDropdown(false);
          },
          buttonDataTest: 'dropdown-button',
          initialFocusRef: textInput
        }, React.createElement("div", {
          className: multiFilterStyles.popoverMenu
        }, React.createElement("div", {
          className: multiFilterStyles.popoverFilter
        }, React.createElement(InputGroup, null, React.createElement(Input.Text.Small, {
          ref: textInput,
          dataTest: 'search-text',
          onChange: this.handleSearchChange,
          defaultValue: searchString
        }), React.createElement(InputGroup.Suffix, {
          size: "small"
        }, React.createElement(Button.Neutral.Small, {
          dataTest: 'search-equals',
          onClick: this.handleSearch,
          loading: this.state.loadingSearch
        }, locale.filter)))), React.createElement(Options, {
          filterOptions: filterOptions,
          filterList: filterList,
          queryOperator: queryOperator,
          handleSearchSelection: this.handleSearchSelection
        }), React.createElement("div", {
          className: multiFilterStyles.popoverClose
        }, React.createElement(Button.Primary.Small, {
          dataTest: 'close-dropdown-button',
          onClick: function onClick() {
            return _this2.toggleDropdown(false);
          }
        }, locale.done))));
      } else {
        inputField = React.createElement(React.Fragment, null, React.createElement(FilterTextMultiFilterInput, {
          filterString: filterString,
          disabled: filterLimitReached || this.props.filtersDisabled,
          queryOperator: queryOperator,
          onChange: this.handleTextChange
        }), React.createElement(FilterTextMultiFilterSuffix, {
          queryOperator: queryOperator,
          disabled: filterLimitReached || this.props.filtersDisabled,
          onClick: this.handleFilterAdd
        }));
      }

      var valueLabel;
      var selectedQueryOperator = sortedFilterOptions.find(function (option) {
        return option.id === queryOperator;
      });

      if (selectedQueryOperator) {
        valueLabel = React.createElement(Icon, {
          icon: selectedQueryOperator.icon
        });
      }

      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: classnames(styles.formItem, multiFilterStyles.container)
      }, React.createElement(Label, null, locale.new), React.createElement(InputGroup, null, React.createElement(InputGroup.Prefix, {
        size: "small"
      }, React.createElement(Select, {
        size: "Small",
        dataTest: changeFilterOperator,
        disabled: this.props.filtersDisabled,
        onChange: this.handleQueryOperatorChange,
        valueLabel: valueLabel,
        value: queryOperator,
        width: "min"
      }, sortedFilterOptions.map(function (option) {
        return React.createElement(Select.Option, {
          key: option.id,
          value: option.id,
          label: option.label,
          prefixIcon: React.createElement(Icon, {
            icon: option.icon
          })
        });
      }))), inputField), largeDataset && (queryOperator === FilterOperators.Equal || queryOperator === FilterOperators.NotEqual) && React.createElement(Text, {
        size: "minimum",
        font: "condensed",
        color: "light",
        dataTest: "large-set-warning"
      }, locale.oversizeWarning), hasFilters && React.createElement("div", {
        className: multiFilterStyles.multiFilterSection
      }, React.createElement(Label, null, locale.added), React.createElement("div", {
        className: multiFilterStyles.filterList
      }, filters.map(function (filter, ndx) {
        return React.createElement("div", {
          className: multiFilterStyles.filterListRow,
          "data-test-filter-row": "filter-".concat(ndx),
          key: "filter-".concat(ndx)
        }, ndx === 0 && React.createElement("div", {
          className: classnames(multiFilterStyles.filterListRowItem, multiFilterStyles.label)
        }, React.createElement(Label, {
          variant: "group"
        }, locale.if)), ndx === 1 && React.createElement("div", {
          className: multiFilterStyles.filterListRowItem
        }, React.createElement(LegacySelect.Small, {
          dataTest: booleanOperatorChangeDataAttribute,
          onChange: _this2.handleBooleanOperatorChange,
          value: booleanOperator,
          width: "min"
        }, React.createElement(LegacySelect.Option, {
          label: BooleanOperators.And,
          value: BooleanOperators.And
        }), React.createElement(LegacySelect.Option, {
          label: BooleanOperators.Or,
          value: BooleanOperators.Or
        }))), ndx > 1 && React.createElement("div", {
          className: classnames(multiFilterStyles.filterListRowItem, multiFilterStyles.label)
        }, React.createElement(Label, {
          variant: "group",
          dataTest: booleanOperatorLabelDataAttribute
        }, booleanOperator)), React.createElement("div", {
          className: classnames(multiFilterStyles.filterListRowItem, multiFilterStyles.label)
        }, React.createElement(InputGroup, null, React.createElement(InputGroup.Prefix, {
          size: "small"
        }, React.createElement(InputGroup.Icon, {
          icon: getIconForOperator(filter.operator)
        })), React.createElement(FilterTextMultiFilterInput, {
          filterString: filter.text,
          disabled: true,
          queryOperator: filter.operator
        }), React.createElement(InputGroup.Suffix, {
          size: "small"
        }, React.createElement(Button.Neutral.Small, {
          dataTest: removeFilterButtonDataAttribute,
          onClick: function onClick() {
            return _this2.handleRemoveFilter(ndx);
          }
        }, React.createElement(Icon, {
          icon: "action-close-small"
        }))))));
      })))), React.createElement(FilterActions, {
        disableApplyButton: !this.state.formIsDirty || this.props.filtersDisabled,
        onClearFilter: this.handleClearFilter,
        onApplyFilter: this.handleApplyFilter
      }));
    }
  }]);

  return FilterTextMulti;
}(React.Component);